import Button from '@oberoninternal/travelbase-ds/components/action/Button';
import Modal from '@oberoninternal/travelbase-ds/components/layout/Modal';
import ModalHeader from '@oberoninternal/travelbase-ds/components/layout/ModalHeader';
import Body from '@oberoninternal/travelbase-ds/components/primitive/Body';
import Title from '@oberoninternal/travelbase-ds/components/primitive/Title';
import useSesame from '@oberoninternal/travelbase-ds/hooks/useSesame';
import { gql } from '@apollo/client';
import React, { FC, Fragment } from 'react';
import { FormattedDate, FormattedMessage } from 'react-intl';
import { CompanyOperatingHoursFragment } from '../generated/graphql';
import Heading from './designsystem/Heading';
import Divider from './Divider';
import OperatingHours from './OperatingHours';

export const fragment = gql`
    fragment CompanyOperatingHours on Company {
        normalOperatingHours {
            monday {
                ...TimeOpenClosed
            }
            tuesday {
                ...TimeOpenClosed
            }
            wednesday {
                ...TimeOpenClosed
            }
            thursday {
                ...TimeOpenClosed
            }
            friday {
                ...TimeOpenClosed
            }
            saturday {
                ...TimeOpenClosed
            }
            sunday {
                ...TimeOpenClosed
            }
        }

        specialOperatingHours {
            startDate
            endDate
            monday {
                ...TimeOpenClosed
            }
            tuesday {
                ...TimeOpenClosed
            }
            wednesday {
                ...TimeOpenClosed
            }
            thursday {
                ...TimeOpenClosed
            }
            friday {
                ...TimeOpenClosed
            }
            saturday {
                ...TimeOpenClosed
            }
            sunday {
                ...TimeOpenClosed
            }
        }
    }
    fragment TimeOpenClosed on TimeOpenClosed {
        timeOpen
        timeClosed
    }
`;

const CompanyOperatingHours: FC<React.PropsWithChildren<{ data: CompanyOperatingHoursFragment }>> = ({
    data: { normalOperatingHours, specialOperatingHours },
}) => {
    const { onClose, open, onOpen } = useSesame();

    return (
        <>
            <Heading mt={5}>
                <Title elementType="h2">
                    <FormattedMessage defaultMessage="Openingstijden" />
                </Title>
            </Heading>
            {normalOperatingHours && <OperatingHours operatingHours={normalOperatingHours} />}
            {!!specialOperatingHours.length && (
                <>
                    <Button onClick={onOpen} variant="outline" style={{ marginTop: '3.2rem' }}>
                        <FormattedMessage defaultMessage="Afwijkende openingstijden" />
                    </Button>

                    <Modal variant="small" open={open} onClose={onClose}>
                        <ModalHeader>
                            <FormattedMessage defaultMessage="Afwijkingen" />
                        </ModalHeader>
                        {specialOperatingHours.map((period, periodIndex) => {
                            if (!period) {
                                return null;
                            }
                            return (
                                <Fragment key={periodIndex}>
                                    <Heading mb={2} mt={4} variant="tiny">
                                        <Body variant="large">
                                            <FormattedMessage
                                                defaultMessage="Van {startDate} t/m {endDate}"
                                                values={{
                                                    startDate: (
                                                        <FormattedDate value={period.startDate} format="WEEKDAYMONTH" />
                                                    ),
                                                    endDate: (
                                                        <FormattedDate value={period.endDate} format="WEEKDAYMONTH" />
                                                    ),
                                                }}
                                            />
                                        </Body>
                                    </Heading>
                                    <OperatingHours operatingHours={period} />
                                    {periodIndex !== specialOperatingHours.length - 1 && <Divider my={4} />}
                                </Fragment>
                            );
                        })}
                    </Modal>
                </>
            )}
        </>
    );
};

export default CompanyOperatingHours;
